import styled from 'styled-components';
import theme from '@/data/theme';

const StyledModalDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  gap: 6px;
  font-weight: 500;
  color: #b6bac3;
  font-family: ${theme.fonts.primary};
`;

const StyledModalDetails = styled.div`
  border: 0.8px solid #b6bac3;
  padding: 0.6rem;
  width: 100%;
  border-radius: 5px;
  font-weight: 400;
  font-size: 12px;
  cursor: not-allowed;
`;

export { StyledModalDetailsWrapper, StyledModalDetails };
